import { FunctionComponent } from "react";

// import * as styles from "./Paywall.css";
import { paywallScript } from "./Paywall.scripts";

/**
 * Paywall component displayed to users who need to subscribe to access content.
 * This is a static component intended for Zephr remote template loading.
 */
const Paywall: FunctionComponent = () => {
  return (
    <>
      <div id="zephr-footer-container" data-brandid={"{{brand-id}}"}>
        <div id="zephr-footer-body">
          <div id="zephr-footer-body-section-1">
            {"{{#body-title-text}}"}
            <span id="zephr-footer-body-title">{"{{body-title-text}}"}</span>
            {"{{/body-title-text}}"}
            {"{{#body-subheading-text}}"}
            <span id="zephr-footer-body-subheading">
              {"{{{body-subheading-text}}}"}
            </span>
            {"{{/body-subheading-text}}"}
          </div>
          <div id="zephr-footer-body-section-2">
            {"{{#body-button-url}}"}
            <button
              id="zephr-footer-body-button"
              {...({
                onclick: 'onSelect("subscribe", "{{body-button-url}}")',
              } as React.ButtonHTMLAttributes<HTMLButtonElement>)}
            >
              {"{{body-button-text}}"}
            </button>
            {"{{/body-button-url}}"}
            <div id="zephr-footer-top" className="zephr-footer-text">
              <span>{"{{email-label}} {{email}}"}</span>
            </div>
            <div id="zephr-footer-bottom">
              <span>
                {"{{#footer-bottom-text}}"}
                <span className="zephr-footer-text">
                  {"{{footer-bottom-text}}"}
                </span>
                {"{{/footer-bottom-text}}"}
                {"{{#footer-bottom-link-url}}"}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  {...({
                    onclick:
                      'onSelect("sign in", "{{footer-bottom-link-url}}")',
                  } as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
                  id="zephr-link-1"
                  className="zephr-footer-text zephr-link"
                  href="#"
                >
                  {"{{footer-bottom-link-text}}"}
                </a>
                {"{{/footer-bottom-link-url}}"}
              </span>

              <span id="zephr-link-divider" />
              <span>
                {"{{#redirect-label}}"}
                <span className="zephr-footer-text">
                  {"{{redirect-label}}"}
                </span>
                {"{{/redirect-label}}"}
                {"{{#redirect-url}}"}
                <a
                  href={"{{redirect-url}}"}
                  {...({
                    onclick: "handleLink2Click()",
                  } as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
                  id="zephr-link-2"
                  className="zephr-footer-text zephr-link"
                >
                  {"{{redirect-url-text}}"}
                </a>
                {"{{/redirect-url}}"}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: paywallScript }} />
    </>
  );
};

export default Paywall;
